import { render, staticRenderFns } from "./send-email.vue?vue&type=template&id=1d1ef0d6&scoped=true&"
import script from "./send-email.vue?vue&type=script&lang=js&"
export * from "./send-email.vue?vue&type=script&lang=js&"
import style0 from "./send-email.vue?vue&type=style&index=0&id=1d1ef0d6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d1ef0d6",
  null
  
)

export default component.exports